import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-4 mb-2" }
const _hoisted_2 = { class: "col-4 mb-2" }
const _hoisted_3 = { class: "col-4 mb-2" }
const _hoisted_4 = { class: "col-4 mb-2" }
const _hoisted_5 = { class: "col-4 mb-2" }
const _hoisted_6 = { class: "col-4 mb-2" }
const _hoisted_7 = { class: "col-4 mb-2" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-4 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelAndValue = _resolveComponent("LabelAndValue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.price',
        value: _ctx.price,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.monthly',
        value: _ctx.monthly,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.duration',
        value: _ctx.duration,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.durationUnit',
        value: _ctx.frequency,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.firstPayment',
        value: _ctx.firstPayment,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.tax',
        value: _ctx.tax,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.divValueStyle)
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            class: _normalizeClass(["d-block font-semi-bold mb-0 font-size color font-weight", _ctx.labelStyle ? _ctx.labelStyle : 'text-muted'])
          }, _toDisplayString(_ctx.$t('summaryPanel.financing.lease.residualValue')), 3)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", {
            class: _normalizeClass(["font-weight margin-left color", _ctx.valueStyle])
          }, [
            (_ctx.proposal.residualValueAmountWTax)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.residualAmountFormatted) + " || ", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle(_ctx.isResidualPercentageHigh ? { color: 'red', fontWeight: 'bold' } : {})
                  }, _toDisplayString(_ctx.residualPercentageFormatted), 5)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ], 2)
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_LabelAndValue, {
        "i18n-key": 'summaryPanel.financing.lease.globalOutstandingHT',
        value: _ctx.globalOutstandingHT,
        oneLine: true,
        "value-style": _ctx.valueStyle,
        "label-style": _ctx.labelStyle,
        "div-value-style": _ctx.divValueStyle
      }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
    ])
  ], 64))
}